@switch($jobStatus | async) {
@case(Status.Invalid) {
<div class="min-h-screen w-full" @fadeAnimation>
    <app-work-order-status />
</div>
}
@case(Status.Active){
<div class="relative mx-auto p-2" @fadeAnimation>
    <app-update-location />

    <div class="w-full p-2">
        <app-tracking-map />
    </div>

    <div class="mt-4 flex flex-col items-center tablet:items-start">
        <div class=" flex flex-col items-center justify-center tablet:flex-row gap-4 w-full">
            <app-avatar-element shape="square" size="xlarge" [image]="tycBoatHeroImg" />
            <app-captain-banner />
            <div class="flex pt-5 gap-2 tablet:ml-auto mr-2">
                <div class="flex flex-col items-center justify-center phone:mr-4">
                    <app-avatar-element shape="square" size="large" [image]="captainPin" />
                    <p>Captains Location</p>
                </div>
                <div class="flex flex-col items-center justify-center phone:ml-4">
                    <app-avatar-element shape="square" size="large" [image]="memberPin" />
                    <p>Your Location</p>
                </div>
            </div>
        </div>
        <div class="w-full flex justify-center mt-3 pt-4">
            <app-call-assistance-btn />
        </div>
    </div>

    <div class="mt-4">
        <app-disclaimer />
    </div>
</div>
<app-spinner />
}
@case(Status.Canceled){
<div class="min-h-screen w-full" @fadeAnimation>
    <app-work-order-status [response]="'statusCanceled'" />
</div>
}
@case(Status.Inactive){
<div class="min-h-screen w-full" @fadeAnimation>
    <app-work-order-status [response]="'statusDone'" />
</div>
}
@case(Status.Summary){
<div class="min-h-screen w-full" @fadeAnimation>
    <app-work-order-status [response]="'statusSummary'" />
</div>
}
@case(Status.Unavailable){
    <app-no-job-id-page @fadeAnimation/>
}
@default{
}
}

<p-toast position="top-center" key="tc"/>
